module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M22 8H2c-1.106 0-2 .894-2 2v20c0 1.106.894 2 2 2h20c1.106 0 2-.894 2-2V10c0-1.106-.894-2-2-2zm-4 13a1 1 0 0 1-1 1h-3v3a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-3H7a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h3v-3a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v3h3a1 1 0 0 1 1 1v2zM10 0C8.894 0 8 .894 8 2v2h18a2 2 0 0 1 2 2v18h2c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2H10z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/add-window-1.js
// module id = 979
// module chunks = 14